/*  /frontend/src/context/LoadingContext.js
    Greatly Social – global loading overlay
    FULL FILE — NOTHING OMITTED
    -------------------------------------------------------------- */

import React, { createContext, useContext, useState } from 'react'
import GlobalLoading from '../components/GlobalLoading'

const LoadingContext = createContext()

export function useLoading() {
  return useContext(LoadingContext)
}

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false)
  const [text,    setText]    = useState('')

  // Show the overlay. If no message (or a falsy value) is passed,
  // we display *only* the spinner.
  const show = (msg) => {
    setText(msg ? msg : '')   // ← default text removed
    setLoading(true)
  }

  const hide = () => {
    setLoading(false)
    setText('')
  }

  return (
    <LoadingContext.Provider value={{ loading, show, hide }}>
      <GlobalLoading show={loading} text={text} />
      {children}
    </LoadingContext.Provider>
  )
}
